export class DictionaryDto<TKey, TValue> extends Array<{ key: TKey; value: TValue }> {}
